import { addDays, fmtTime } from "./dates";

const esc = (s = "") => String(s).replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/[,;]/g, (c) => `\\${c}`);
const compact = (iso) => iso.replace(/-/g, "");
const stamp = () => new Date().toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";

export function vevent({ uid, title, description, location, date, startTime, endTime, endDate }) {
  const lines = ["BEGIN:VEVENT", `UID:${uid}@marys-china-adventure`, `DTSTAMP:${stamp()}`, `SUMMARY:${esc(title)}`];
  if (startTime) {
    lines.push(`DTSTART:${compact(date)}T${startTime.replace(":", "")}00`);
    if (endTime) lines.push(`DTEND:${compact(date)}T${endTime.replace(":", "")}00`);
  } else {
    lines.push(`DTSTART;VALUE=DATE:${compact(date)}`);
    lines.push(`DTEND;VALUE=DATE:${compact(endDate || addDays(date, 1))}`);
  }
  if (description) lines.push(`DESCRIPTION:${esc(description)}`);
  if (location) lines.push(`LOCATION:${esc(location)}`);
  lines.push("END:VEVENT");
  return lines.join("\r\n");
}

export const wrap = (events) =>
  ["BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Marys Birthday China Adventure//EN", "CALSCALE:GREGORIAN", ...events, "END:VCALENDAR"].join("\r\n");

export function download(filename, ics) {
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; document.body.appendChild(a); a.click();
  setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 500);
}

export const eventToV = (e) => vevent({
  uid: e.id, title: e.title, date: e.date, startTime: e.startTime, endTime: e.endTime,
  description: [e.description, e.notes, `Status: ${e.status}`].filter(Boolean).join("\n"),
  location: [e.address, e.addressChinese].filter(Boolean).join(" / ") || e.city,
});

export const hotelToV = (h) => vevent({
  uid: `stay-${h.id}`, title: `Stay: ${h.name} (${h.city})`, date: h.checkIn, endDate: h.checkOut,
  description: `${h.nights} nights · ${h.roomSummary}\n${h.address}\n${h.addressChinese}${h.notes ? `\n${h.notes}` : ""}`,
  location: `${h.address} / ${h.addressChinese}`,
});

export const transportToV = (t) => vevent({
  uid: `transport-${t.id}`, title: t.title, date: t.date, startTime: t.departTime, endTime: t.arriveTime,
  description: [t.carrier, t.duration && `Approx. ${t.duration}`, t.missing?.length && `TBC: ${t.missing.join(", ")}`, t.notes].filter(Boolean).join("\n"),
  location: t.toPlace || t.toCity,
});

export const dayToICS = (date, { events, hotels, transports }) => wrap([
  ...transports.filter((t) => t.date === date).map(transportToV),
  ...hotels.filter((h) => h.checkIn === date).map(hotelToV),
  ...events.filter((e) => e.date === date).map(eventToV),
]);

export const tripToICS = ({ events, hotels, transports }) =>
  wrap([...transports.map(transportToV), ...hotels.map(hotelToV), ...events.map(eventToV)]);

export function googleUrl({ title, date, startTime, endTime, endDate, description, location }) {
  const dates = startTime
    ? `${compact(date)}T${startTime.replace(":", "")}00/${compact(date)}T${(endTime || startTime).replace(":", "")}00`
    : `${compact(date)}/${compact(endDate || addDays(date, 1))}`;
  const p = new URLSearchParams({ action: "TEMPLATE", text: title, dates, details: description || "", location: location || "" });
  return `https://calendar.google.com/calendar/render?${p}`;
}

export const describeTiming = (e) => (e.startTime ? `${fmtTime(e.startTime)}${e.endTime ? ` → ${fmtTime(e.endTime)}` : ""}` : "All day · time not set");
